import { Component, ElementRef, HostListener, Input, OnInit, Renderer2, ViewChild } from '@angular/core';

type componentHolderTypes = "component" | "button";

@Component({
  selector: 'app-component-holder',
  templateUrl: './component-holder.component.html',
  styleUrls: ['./component-holder.component.scss'],
})
export class ComponentHolderComponent implements OnInit {

  @ViewChild('holder') componentHolder!: ElementRef;

  @Input() type:componentHolderTypes = "component";

  constructor(
    private renderer: Renderer2,
  ) { }

  ngOnInit(): void {
  }

  @HostListener('mouseenter') 
  onMouseEnter() {
    // this.renderer.setStyle(this.componentHolder.nativeElement, 'transform', 'scale(1.01)');
    // this.renderer.setStyle(this.componentHolder.nativeElement, 'box-shadow', '3px 3px 10px grey');
    // this.renderer.setStyle(this.componentHolder.nativeElement, 'border-bottom-left-radius', '0%');
    // this.renderer.setStyle(this.componentHolder.nativeElement, 'border-bottom-right-radius', '0%');
  }

  @HostListener('mouseleave') 
  onMouseLeave() {
    // this.renderer.removeStyle(this.componentHolder.nativeElement, 'transform');
    // this.renderer.removeStyle(this.componentHolder.nativeElement, 'box-shadow');
    // this.renderer.removeStyle(this.componentHolder.nativeElement, 'border-bottom-left-radius');
    // this.renderer.removeStyle(this.componentHolder.nativeElement, 'border-bottom-right-radius');
  }
}
